import React, { JSX } from 'react';
import Breadcrumbs from './Breadcrumbs';
import Style from './Layout.module.scss';

const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }): JSX.Element => {
  return (
    <div className={Style.wrapper}>
      <Breadcrumbs />
      <div className={Style.container}>{children}</div>
      <Breadcrumbs />
    </div>
  );
};

export default Layout;
